import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IMAGES } from '../../constants/images';

export const HomeWhyUs = () => (
  <section className="py-24 bg-[#0f172a]" data-testid="why-us-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <span className="inline-block px-4 py-2 bg-white/10 rounded-full text-sm font-medium text-[#00bcd4] mb-6">
            Why Choose Us
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-6">
            A Decade of Trust and Excellence
          </h2>
          <p className="text-slate-400 leading-relaxed mb-8">
            Since 2014, we have been committed to providing transparent, efficient, 
            and result-oriented financial consultancy services. Our D2D (Documentation to Disbursement) 
            model ensures complete support throughout your journey.
          </p>
          <ul className="space-y-4">
            {[
              'Expert team of Chartered Accountants',
              'Pan-India government subsidy expertise',
              'Strong banking relationships',
              'End-to-end documentation support',
              'Transparent fee structure'
            ].map((item, index) => (
              <li key={index} className="flex items-center gap-3 text-slate-300">
                <span className="w-2 h-2 rounded-full bg-[#00bcd4]"></span>
                {item}
              </li>
            ))}
          </ul>
          <Link
            to="/leadership"
            data-testid="why-us-cta"
            className="inline-flex items-center gap-2 gradient-btn px-8 py-4 rounded-full font-medium text-white mt-8"
          >
            Meet Our Team
            <ArrowRight size={18} />
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="relative"
        >
          <img
            src={IMAGES.foundersCover}
            alt="Our Founders"
            className="rounded-2xl shadow-2xl w-full object-cover"
          />
        </motion.div>
      </div>
    </div>
  </section>
);
